// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e484934","455":"6ce1e322","977":"67f808e1"}[chunkId] + ".chunk.js";
};